// hooks/useMapItems.js
import { useMemo } from "react";

/**
 * @typedef {Object} MapItem
 * @property {string} id
 * @property {string} type
 * @property {number} lat
 * @property {number} lng
 * @property {string} name
 * @property {Array}  [coordinates] - polygon boundary coords, zones only
 */

/**
 * @typedef {Object} UseMapItemsResult
 * @property {MapItem[]} items - all non-zone items
 * @property {MapItem[]} zones - all zone items
 */

/**
 * Splits raw API data into zones and non-zone items.
 * Only re-derives when data reference changes.
 *
 * @param {MapItem[]} data - raw array from useMapData
 * @returns {UseMapItemsResult}
 */
export function useMapItems(data, showNearByAssets, showNearByZones) {
  const items = useMemo(() => {
    return showNearByAssets ? data.filter((item) => item.type !== "zone") : [];
  }, [data, showNearByAssets]);

  const zones = useMemo(() => {
    return showNearByZones ? data.filter((item) => item.type === "zone") : [];
  }, [data, showNearByZones]);

  return { items, zones };
}
